import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { PriorityIcon } from "src/modules/support/components/SupportPriorityDropdown";
import {
  ISupportTicket,
  SupportTicketPriority
} from "src/modules/support/api/support.api";
import { Tooltip } from "src/library/components/Tooltip";

export const supportTicketPriorityColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: accessor,
    size: 40,
    header: () => {
      return (
        <Icon
          icon={Icons.PRIORITY}
          size={20}
        />
      );
    },
    sortable: true,
    cell: info => {
      const supportTicket = info.row.original as ISupportTicket;

      return (
        <>
          <div
            data-tip
            data-for={info.cell.getValue()}
          >
            <PriorityIcon level={supportTicket.priority ? supportTicket.priority : SupportTicketPriority.Medium} />
          </div>

          <Tooltip
            id={info.cell.getValue() as string}
            type="dark"
            place="right"
            getContent={() => {
              return (
                <Text
                  color="white"
                  textTransform="capitalize"
                >
                  {`${info.cell.getValue()} priority`}
                </Text>
              );
            }}
          />
        </>
      );
    }
  } as DisplayColumnDef<TData>);
};